export const BILLING_WEBHOOK_QUEUE = 'billing-webhook';

export type BillingWebhookJob = {
  stripeEventId: string;
  type: string;
};

export type EmbeddedCheckoutSessionResult = {
  sessionId: string;
  clientSecret: string;
};

export type BillingPortalSessionResult = {
  url: string;
};

export type StripeSubscriptionSnapshot = {
  stripeSubscriptionId: string;
  stripeCustomerId: string;
  stripePriceId: string | null;
  status: string;
  billingInterval: 'month' | 'year' | null;
  cancelAtPeriodEnd: boolean;
  currentPeriodStart: Date | null;
  currentPeriodEnd: Date | null;
  pauseCollectionActive?: boolean;
  pauseResumesAt?: Date | null;
};
